import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/locale/i18n'

Vue.use(Router)

const routes = [
    {
        path: '*',
        name: 'CV Submission',
        meta: {
            title: 'Υποβολή CV'
        },
        component: () => import('@/components/routes/SubmissionRoute')
    }
]


const router = new Router({
    mode: 'history',
    routes: routes
})

router.beforeEach((to, from, next) => {
    const langFromLocalStorage = localStorage.getItem('lang')
    const lang = to.query.lang || langFromLocalStorage || 'el'
    localStorage.setItem('lang', lang)
    i18n.locale = lang

    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    if (nearestWithTitle) {
        document.title = 'ΚΑΠΝΟΒΙΟΜΗΧΑΝΙΑ ΚΑΡΕΛΙΑ Α.Ε. - ' + nearestWithTitle.meta.title
    }
    next()
})


export default router
